import { IPremadeQuiz } from '@quizzach/interfaces';
import { CardsGrid } from '@quizzach/styles';
import { PremadeLoadingSkeleton } from './Premade-Skeleton';
import { PremadeQuizCardComponent } from './PremadeCard';

// One responsive grid + card for all form factors (the desktop/mobile card
// split had no behavioral differences beyond layout).
export const QuizGrid = ({
	quizzes,
	loading,
	error,
	numberOfQuizzes,
}: {
	quizzes: IPremadeQuiz[] | undefined;
	loading: boolean;
	error?: boolean;
	numberOfQuizzes?: number;
}) => (
	<CardsGrid>
		{loading && (
			<PremadeLoadingSkeleton numberOfQuizzes={numberOfQuizzes || 8} />
		)}
		{!loading &&
			!error &&
			quizzes
				?.slice(0, numberOfQuizzes ?? quizzes.length)
				?.map((quiz) => (
					<PremadeQuizCardComponent key={quiz.uuid} quiz={quiz} />
				))}
	</CardsGrid>
);
